import classes from "./Measurement.module.css";
import L from "leaflet";
import { Marker, MarkerProps } from "react-leaflet";

type Props = {
  text: string | number;
};

export const MouseLabelMarker = ({ text, ...rest }: Props & MarkerProps) => {
  const distanceIcon = L.divIcon({
    html: `<div><div class="${classes.mouseLabel}">${text}</div></div>`,
    className: classes.mouseLabelMarker,
    iconSize: [100, 20],
    iconAnchor: [50, 30],
  });

  return <Marker interactive={false} icon={distanceIcon} {...rest} />;
};
